import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { EmbedBlock } from '@app/infrastructure/models/embed-block';

@Component({
  selector: 'app-embed-block-viewer',
  templateUrl: './embed-block-viewer.component.html',
  styleUrls: ['./embed-block-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmbedBlockViewerComponent implements OnInit {
  @Input() embed: EmbedBlock = new EmbedBlock();

  html: SafeHtml;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.html = this.sanitizer.bypassSecurityTrustHtml(this.embed.html);
  }
}
